import { useEffect } from 'react';
import { HeroSection, StatsBand } from '@/components/home/HeroSection';
import { GroupIntro } from '@/components/home/GroupIntro';
import { BrandsGrid } from '@/components/home/CoreSections';
import { WhyEurogulf, FinalCta } from '@/components/home/TrustSectionsV2';
import { Timeline } from '@/components/home/Timeline';

export default function HomePage() {
  useEffect(() => { document.title = "Eurogulf Mobility Group | We Move You! | The UAE's Most Trusted Name in Mobility Since 1976"; }, []);

  return (
    <div data-testid="home-page">
      <HeroSection />
      <StatsBand />
      <GroupIntro />
      <BrandsGrid />
      <Timeline />
      <WhyEurogulf />
      <FinalCta />
    </div>
  );
}
